
const digest = '50d3de70416453364b980a4d7882e9d0b386f83ff6df78dc72be21be1c4c3632';
const classes = {"item":"_item_12b5k_1","active":"_active_12b5k_9","disabled":"_disabled_12b5k_19"};
const css = `._item_12b5k_1 {
  color: #1665d8;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  padding: 12px 0;
}
._item_12b5k_1._active_12b5k_9 {
  color: #1553aa;
  background-color: #dce7f9;
  border-radius: 5px;
  text-decoration: none;
  padding: 5px 10px;
  margin: 7px 0;
  height: fit-content;
  margin: 7px 0;
}
._item_12b5k_1._disabled_12b5k_19 {
  color: #737373;
  cursor: not-allowed;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  